<template>
<div class="chapter">
<div class="inner_page">
<p class="chap"><b>Standard Quilt Sizes</b></p>
<p class="h1" id="c-1"><i>Bed, Comforter, Coverlet, and Bedspread Measurements</i></p>
<p class="fig"><img alt="" src="images/5.jpg"/></p>
<p class="fcap"><i>Comforters cover the mattress but not the box spring and generally don’t have a pillow tuck. Coverlets cover the mattress and box spring and generally have a pillow tuck. Bedspreads cover the bed to almost the floor and have a pillow tuck.</i></p>
<p class="h1" id="c-2"><i>Quilt Sizes with Drop and Tuck</i></p>
<p class="fig"><img alt="" src="images/5a.jpg"/></p>
<p class="fcap"><i>Drop hangs over the edge of the mattress on 3 sides. Tuck folds under the pillow.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?28a5d4e3